import { CheckCircleFilled } from '@ant-design/icons';
import { Row, Col } from 'antd';
import { useScrollTop } from 'hooks';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ButtonSubmit } from 'components';
import { resetState } from '../slices';
import Wrap from './styles';

type Props = {
  itemId: string;
  redirectToFirstStep: Function;
};

const RegisterStepFour = ({ itemId, redirectToFirstStep }: Props) => {
  useScrollTop();
  const dispatch = useDispatch();
  const history = useHistory();

  const nextPatient = () => {
    dispatch(resetState());
    redirectToFirstStep();
  };

  const detailNewItem = () => {
    dispatch(resetState());
    history.push('/cpap/detail', { itemId, omitWarningLeavePage: true });
  };

  return (
    <Wrap>
      <CheckCircleFilled className="icon" />
      <p className="middleBoldFont">CPAP指示書の登録が完了しました。</p>
      <Row justify="center">
        <Col span={11}>
          <ButtonSubmit action={detailNewItem} width="338px" height="60px" titleButton="登録内容を表示" />
        </Col>
        <Col span={11} offset={2}>
          <ButtonSubmit action={nextPatient} width="338px" height="60px" titleButton="引き続き患者を新規登録する" />
        </Col>
      </Row>
    </Wrap>
  );
};

export default RegisterStepFour;
